import { createStore } from "redux";
import state from "./state";
import thunk from "redux-thunk";
import { applyMiddleware } from "redux";

export default createStore(state, applyMiddleware(thunk));
